import { render, staticRenderFns } from "./ContactRegisterReport.vue?vue&type=template&id=bd58dc36&scoped=true&"
import script from "./ContactRegisterReport.vue?vue&type=script&lang=js&"
export * from "./ContactRegisterReport.vue?vue&type=script&lang=js&"
import style0 from "./ContactRegisterReport.vue?vue&type=style&index=0&id=bd58dc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd58dc36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VTab,VTabItem,VTabs,VTabsSlider})
